<template>
  <span
      v-if="show"
      class="stitek"
      :class="videoClass"
  >{{videoQualityText}}</span>
</template>

<script>
export default {
  name: "ChannelVideoQualityLabel",
  props: {
    quality: String,
  },
  beforeDestroy() {
  },
  mounted() {
  },
  computed: {
    show(){
      return this.videoQualityText != 'SD';
    },
    videoQualityText(){
      return this.quality ? this.quality.toUpperCase() : 'N/A';
    },
    videoClass(){
      return 'stitek--'+this.videoQualityText.toLowerCase();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/ChannelVideoQualityLabel.vue